var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plug"},[_c('PlugIcon',{staticClass:"plug__icon",style:(_vm.cssVars)}),_c('h4',{staticClass:"plug__text",class:'f' + _vm.fontSize},[_vm._v(" "+_vm._s(_vm.localStorage.translations.pages.common['text']['net-dannyh'])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }